var XVISION_KONKA_D2 = {
    name: "KONKA_D2",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [75,0,6,78,2,110,5,79,2,78,9,22,12,60,11,80,2,14,15,95,2,49,89,94,2,0,0,63,191,106,33,63,191,106,32,128],
        },
        {
            function: "KEY_INPUT",
            name: "KEY_INPUT",
            icon: "KEY_INPUT",
            command: [75,0,6,78,2,111,5,78,2,80,9,15,12,63,11,77,2,23,15,93,2,45,89,88,2,0,0,63,190,174,33,63,190,174,32,128],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [75,0,6,79,2,109,5,80,2,80,9,3,12,64,11,79,2,27,15,83,2,253,96,96,2,0,0,63,191,232,132,254,255,162,8],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [75,0,6,77,2,109,5,78,2,82,9,40,12,59,11,77,2,20,15,86,2,179,96,90,2,0,0,63,191,216,132,254,255,98,8],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [75,0,6,77,2,112,5,77,2,83,9,11,12,62,11,77,2,15,15,96,2,31,93,84,2,0,0,63,191,212,66,127,127,168,130],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [75,0,6,75,2,112,5,76,2,83,9,5,12,69,11,76,2,23,15,87,2,5,97,87,2,0,0,63,191,184,132,254,254,226,8],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [75,0,6,74,2,112,5,76,2,83,9,9,12,68,11,77,2,14,15,85,2,35,93,94,2,0,0,63,191,180,66,127,127,104,130],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [75,0,6,75,2,112,5,74,2,84,9,7,12,68,11,78,2,3,15,88,2,28,93,122,2,0,0,63,191,172,66,127,127,88,130],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [75,0,6,77,2,111,5,77,2,80,9,19,12,57,11,78,2,13,15,97,2,53,89,90,2,0,0,63,191,170,33,63,191,170,32,128],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [75,0,6,75,2,112,5,76,2,85,9,5,12,70,11,75,2,24,15,100,2,250,96,85,2,0,0,63,191,120,132,254,253,226,8],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [75,0,6,71,2,114,5,74,2,85,9,0,12,61,11,71,2,24,15,89,2,42,93,80,2,0,0,63,191,116,66,127,126,232,130],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [75,0,6,70,2,115,5,9,12,67,11,71,2,69,9,71,2,22,15,89,2,232,100,79,2,0,0,127,63,241,11,249,255,136,32],
        },
        {
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [75,0,6,78,2,109,5,79,2,79,9,9,12,58,11,79,2,31,15,87,2,19,93,81,2,0,0,63,190,220,66,127,125,184,130],
        },
        {
            function: "KEY_AUDIO_LANG",
            name: "KEY_AUDIO_LANG",
            icon: "KEY_AUDIO_LANG",
            command: [75,0,6,73,2,111,5,72,2,85,9,7,12,66,11,76,2,17,15,92,2,31,93,85,2,0,0,63,189,236,66,127,123,216,130],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [75,0,6,78,2,109,5,79,2,78,9,8,12,62,11,82,2,19,15,93,2,48,89,96,2,0,0,63,190,234,33,63,190,234,32,128],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [75,0,6,79,2,108,5,80,2,77,9,15,12,52,11,82,2,33,15,80,2,18,93,80,2,0,0,63,190,236,66,127,125,216,130],
        },
        {
            function: "KEY_CHANNELUP",
            name: "KEY_CHANNELUP",
            icon: "KEY_CHANNELUP",
            command: [75,0,6,79,2,108,5,79,2,79,9,11,12,62,11,80,2,23,15,87,2,12,93,95,2,0,0,63,190,244,66,127,125,232,130],
        },
        {
            function: "KEY_CHANNELDOWN",
            name: "KEY_CHANNELDOWN",
            icon: "KEY_CHANNELDOWN",
            command: [75,0,6,77,2,110,5,78,2,80,9,21,12,56,11,79,2,23,15,91,2,250,96,89,2,0,0,63,190,248,132,254,251,226,8],
        },
        {
            function: "KEY_TV",
            name: "KEY_TV",
            icon: "KEY_TV",
            command: [75,0,6,71,2,115,5,72,2,86,9,4,12,61,11,76,2,13,15,94,2,107,85,88,2,0,0,63,186,245,16,159,221,122,136,32],
        },
        {
            function: "KEY_MORE",
            name: "KEY_MORE",
            icon: "KEY_MORE",
            command: [75,0,6,72,2,114,5,72,2,85,9,7,12,60,11,75,2,24,15,80,2,75,89,81,2,0,0,63,186,246,33,63,186,246,32,128],
        },
        {
            function: "KEY_GUIDE",
            name: "KEY_GUIDE",
            icon: "KEY_GUIDE",
            command: [75,0,6,73,2,114,5,74,2,85,9,24,12,70,11,73,2,26,15,82,2,54,85,80,2,0,0,63,189,107,16,159,222,181,136,32],
        },
        {
            function: "KEY_REC_LIST",
            name: "KEY_REC_LIST",
            icon: "KEY_REC_LIST",
            command: [75,0,6,71,2,116,5,75,2,77,9,5,12,59,11,90,2,27,15,83,2,99,85,83,2,0,0,63,189,213,16,159,222,234,136,32],
        },
        {
            function: "KEY_BACK",
            name: "KEY_BACK",
            icon: "KEY_BACK",
            command: [75,0,6,74,2,114,5,74,2,85,9,8,12,43,11,75,2,24,15,83,2,27,93,80,2,0,0,63,189,124,66,127,122,248,130],
        },
        {
            function: "KEY_HOME",
            name: "KEY_HOME",
            icon: "KEY_HOME",
            command: [75,0,6,73,2,114,5,73,2,86,9,7,12,63,11,74,2,7,15,109,2,76,89,90,2,0,0,63,189,110,33,63,189,110,32,128],
        },
        {
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [75,0,6,73,2,114,5,73,2,84,9,3,12,67,11,74,2,2,15,119,2,68,89,83,2,0,0,63,190,218,33,63,190,218,32,128],
        },
        {
            function: "KEY_UP",
            name: "KEY_UP",
            icon: "KEY_UP",
            command: [75,0,6,70,2,117,5,73,2,82,9,8,12,58,11,81,2,19,15,92,2,97,85,82,2,0,0,63,189,181,16,159,222,218,136,32],
        },
        {
            function: "KEY_DOWN",
            name: "KEY_DOWN",
            icon: "KEY_DOWN",
            command: [75,0,6,70,2,115,5,70,2,82,9,9,12,68,11,75,2,25,15,80,2,69,89,78,2,0,0,63,189,174,33,63,189,174,32,128],
        },
        {
            function: "KEY_LEFT",
            name: "KEY_LEFT",
            icon: "KEY_LEFT",
            command: [75,0,6,73,2,114,5,71,2,83,9,6,12,60,11,75,2,17,15,92,2,111,85,91,2,0,0,63,189,173,16,159,222,214,136,32],
        },
        {
            function: "KEY_RIGHT",
            name: "KEY_RIGHT",
            icon: "KEY_RIGHT",
            command: [75,0,6,70,2,116,5,76,2,72,9,9,12,65,11,80,2,26,15,86,2,97,85,93,2,0,0,63,189,171,16,159,222,213,136,32],
        },
        {
            function: "KEY_OK",
            name: "KEY_OK",
            icon: "KEY_OK",
            command: [75,0,6,72,2,116,5,77,2,72,9,8,12,53,11,85,2,35,15,80,2,126,81,82,2,0,0,63,189,170,136,79,239,106,162,8],
        },
        {
            function: "KEY_RED",
            name: "KEY_RED",
            icon: "KEY_RED",
            command: [75,0,6,72,2,115,5,76,2,73,9,11,12,63,11,73,2,18,15,87,2,63,89,85,2,0,0,63,190,182,33,63,190,182,32,128],
        },
        {
            function: "KEY_GREEN",
            name: "KEY_GREEN",
            icon: "KEY_GREEN",
            command: [75,0,6,71,2,116,5,80,2,72,9,14,12,66,11,87,2,32,15,79,2,144,81,94,2,0,0,63,190,170,136,79,239,170,162,8],
        },
        {
            function: "KEY_YELLOW",
            name: "KEY_YELLOW",
            icon: "KEY_YELLOW",
            command: [75,0,6,70,2,116,5,73,2,74,9,7,12,63,11,72,2,20,15,81,2,50,93,90,2,0,0,63,191,92,66,127,126,184,130],
        },
        {
            function: "KEY_BLUE",
            name: "KEY_BLUE",
            icon: "KEY_BLUE",
            command: [75,0,6,72,2,115,5,74,2,74,9,15,12,66,11,80,2,21,15,90,2,64,89,79,2,0,0,63,190,214,33,63,190,214,32,128],
        },
        {
            function: "KEY_INFO",
            name: "KEY_INFO",
            icon: "KEY_INFO",
            command: [75,0,6,72,2,114,5,73,2,86,9,11,12,66,11,72,2,17,15,93,2,36,93,88,2,0,0,63,191,108,66,127,126,216,130],
        },
        {
            function: "KEY_RECALL",
            name: "KEY_RECALL",
            icon: "KEY_RECALL",
            command: [75,0,6,71,2,114,5,74,2,84,9,7,12,69,11,73,2,20,15,89,2,64,89,86,2,0,0,63,191,86,33,63,191,86,32,128],
        },
        {
            function: "KEY_RECORD_STOP",
            name: "KEY_RECORD_STOP",
            icon: "KEY_RECORD_STOP",
            command: [75,0,6,73,2,114,5,73,2,84,9,8,12,69,11,78,2,16,15,85,2,96,85,86,2,0,0,63,190,213,16,159,223,106,136,32],
        },
        {
            function: "KEY_REWIND",
            name: "KEY_REWIND",
            icon: "KEY_REWIND",
            command: [75,0,6,72,2,114,5,73,2,87,9,4,12,63,11,74,2,23,15,87,2,79,89,84,2,0,0,63,189,94,33,63,189,94,32,128],
        },
        {
            function: "KEY_PLAYPAUSE",
            name: "KEY_PLAYPAUSE",
            icon: "KEY_PLAYPAUSE",
            command: [75,0,6,71,2,116,5,70,2,82,9,5,12,60,11,83,2,25,15,81,2,78,89,81,2,0,0,63,190,186,33,63,190,186,32,128],
        },
        {
            function: "KEY_FORWARD",
            name: "KEY_FORWARD",
            icon: "KEY_FORWARD",
            command: [75,0,6,71,2,116,5,74,2,74,9,13,12,62,11,90,2,21,15,91,2,141,81,85,2,0,0,63,189,106,136,79,239,90,162,8],
        },
        {
            function: "KEY_ASPECT",
            name: "KEY_ASPECT",
            icon: "KEY_ASPECT",
            command: [75,0,6,78,2,110,5,79,2,78,9,7,12,62,11,80,2,27,15,94,2,54,89,79,2,0,0,63,189,122,33,63,189,122,32,128],
        },
        {
            function: "KEY_SLEEP",
            name: "KEY_SLEEP",
            icon: "KEY_SLEEP",
            command: [75,0,6,78,2,109,5,79,2,79,9,4,12,60,11,80,2,22,15,91,2,56,89,91,2,0,0,63,189,218,33,63,189,218,32,128],
        },
        {
            function: "KEY_SOUND",
            name: "KEY_SOUND",
            icon: "KEY_SOUND",
            command: [75,0,6,78,2,109,5,78,2,79,9,10,12,63,11,79,2,11,15,105,2,81,85,98,2,0,0,63,191,85,16,159,223,170,136,32],
        },
        {
            function: "PICTURE",
            name: "PICTURE",
            icon: "PICTURE",
            command: [75,0,6,77,2,110,5,78,2,79,9,5,12,58,11,77,2,20,15,91,2,58,89,90,2,0,0,63,189,234,33,63,189,234,32,128],
        },
        {
            function: "KEY_SUBTITLE",
            name: "KEY_SUBTITLE",
            icon: "KEY_SUBTITLE",
            command: [75,0,6,80,2,108,5,79,2,80,9,10,12,64,11,82,2,36,15,81,2,26,93,80,2,0,0,63,190,188,66,127,125,120,130],
        },
    ]
}
export default XVISION_KONKA_D2